export default "assets/images/footer-shape-abe51d9f.svg";